<div fxLayout="row">
  <mat-tab-group fxFlex>
    <mat-tab *ngFor="let process of processLists" [label]="process['processName']"> 
      <div *ngFor="let role of process['roles']">
        <h4 class="happ-ws-settings-heading">
            {{ role['label'] }}
        </h4>
        <div fxLayout="row wrap" class="mb-16" style="width: 96%; margin: auto;">
          <button (click)="addRole(process, role, user.email)" class="happ-small-button" *ngFor="let user of usersList" mat-raised-button [color]="(rolesAccess && rolesAccess[process['id']] && rolesAccess[process['id']][role['id']] && rolesAccess[process['id']][role['id']].includes(user.email)) ? 'primary' : ''" > {{ user.email }} </button>
        </div>
      </div> 
    </mat-tab>
  </mat-tab-group>
  <div style="width: 25%;" class="p-12">
    <p class="hint-text font-size-18">
      Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
    </p>
  </div>
</div>